module.exports = __webpack_public_path__ + "img/vegetarian-chili.7db0f952.jpg";